module.exports = __webpack_public_path__ + "static/media/copyLink.6bb18e01.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/GuruProfile/copyLink.png
// module id = 2580
// module chunks = 0